(function () {
  var MENU_VIEW_MIN_MS = 300;
  var SCROLL_MARKS = [25, 50, 75, 100];

  function track(name, params) {
    if (typeof window.ghiaTrack !== "function") return;
    window.ghiaTrack(name, params);
  }

  function attr(el, name) {
    return el && el.getAttribute ? el.getAttribute(name) || "" : "";
  }

  function handleFor(link) {
    var own = attr(link, "data-gift-handle");
    if (own) return own;
    var holder = link.closest("[data-gift-handle], [data-product-handle]");
    if (!holder) return "";
    return attr(holder, "data-gift-handle") || attr(holder, "data-product-handle");
  }

  function actionFor(link, href) {
    var own = attr(link, "data-gift-action");
    if (own) return own;
    if (link.classList.contains("product-card__panel")) return "card_cta";
    if (href.indexOf("product_id=") !== -1) return "card";
    return "link";
  }

  function skipTrigger(link) {
    if (!link.hasAttribute("data-menu-trigger")) return false;
    if (window.matchMedia("(hover: hover)").matches) return false;
    return link.getAttribute("aria-expanded") !== "true";
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") return;

      var link = target.closest("a[href]");
      if (!link) return;

      var area = link.closest("[data-gift-area]");
      if (!area) return;
      if (skipTrigger(link)) return;

      var href = link.getAttribute("href") || "";
      track("gift_click", {
        gift_source: attr(area, "data-gift-area"),
        gift_action: actionFor(link, href),
        product_handle: handleFor(link),
        link_url: href,
      });
    },
    true
  );

  var panel = document.getElementById("gift-menu");
  if (panel && typeof MutationObserver === "function") {
    var openTimer = null;
    var observer = new MutationObserver(function () {
      var isOpen = panel.classList.contains("is-open");
      if (isOpen && openTimer === null) {
        openTimer = setTimeout(function () {
          openTimer = null;
          track("gift_menu_view", { gift_source: "mega_menu" });
        }, MENU_VIEW_MIN_MS);
      } else if (!isOpen && openTimer !== null) {
        clearTimeout(openTimer);
        openTimer = null;
      }
    });
    observer.observe(panel, { attributes: true, attributeFilter: ["class"] });
  }

  var sections = Array.prototype.slice.call(document.querySelectorAll("[data-gift-section]"));
  var callouts = Array.prototype.slice.call(document.querySelectorAll("[data-gift-callout]"));

  if (typeof IntersectionObserver === "function" && (sections.length || callouts.length)) {
    var seen = {};
    var viewer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var key = el.hasAttribute("data-gift-callout") ? "callout" : attr(el, "data-gift-section");
          if (seen[key]) return;
          seen[key] = true;
          viewer.unobserve(el);

          if (key === "callout") {
            track("gift_callout_view", {
              gift_source: attr(el, "data-gift-area"),
              product_handle: attr(el, "data-gift-handle"),
            });
          } else {
            track("gift_section_view", { gift_section: key });
          }
        });
      },
      { rootMargin: "0px 0px -25% 0px", threshold: 0 }
    );
    sections.concat(callouts).forEach(function (el) {
      viewer.observe(el);
    });
  }

  if (sections.length) {
    var reached = {};
    var ticking = false;

    var measure = function () {
      ticking = false;
      var doc = document.documentElement;
      var total = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
      if (!total) return;
      var seenHeight = window.scrollY + window.innerHeight;
      var percent = Math.min(100, Math.round((seenHeight / total) * 100));

      SCROLL_MARKS.forEach(function (mark) {
        if (reached[mark] || percent < mark) return;
        reached[mark] = true;
        track("gift_page_scroll", { percent_scrolled: mark });
      });
    };

    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(measure);
      },
      { passive: true }
    );
    window.addEventListener("load", measure);
    measure();
  }
})();
